import React from 'react';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { BillTo, Quote, Maybe } from '@css-xp/graphtypes/src/generated-types-sxp';
import { QuoteWidgetItem, CommonWidgetItem } from '../../widget';
import QuoteIcon from '../../widget/src/assets/quote-icon.svg';

type Quotes =
  | Maybe<
      Array<
        Maybe<
          Pick<
            Quote,
            'id' | 'transactionAccountId' | 'quoteNumber' | 'createdDate' | 'expiryDate' | 'currency' | 'total'
          > & {
            shipToObject?: Maybe<Pick<BillTo, 'displayName'>>;
          }
        >
      >
    >
  | undefined;

export const getRecentGeneratedQuotesWidgetContent = (quotes: Quotes, heading?: string, version?: number) => {
  if (!quotes || !quotes.length) {
    return null;
  }

  return quotes.map((quotes, index) => {
    if (!quotes || !quotes.transactionAccountId || !quotes.id) {
      return null;
    }
    const URL = getRouteUrl(routePaths.ppcQuoteDetails, { txaId: quotes.transactionAccountId, quoteId: quotes.id });

    if (version === 2) {
      return (
        <CommonWidgetItem
          url={URL}
          key={quotes.quoteNumber}
          heading={heading}
          icon={QuoteIcon}
          createdDate={quotes.createdDate as string}
          expiryDate={quotes.expiryDate as string}
          currency={quotes.currency as string}
          total={quotes.total as string}
          leftText={quotes.quoteNumber}
          company={quotes?.shipToObject?.displayName}
        />
      );
    }

    return (
      <QuoteWidgetItem
        quoteNumber={quotes.quoteNumber}
        timestamp={quotes.createdDate}
        company={quotes?.shipToObject?.displayName}
        url={URL}
        key={index}
        heading={heading}
      />
    );
  });
};
